module.exports = __webpack_public_path__ + "img/Jorge_Perez_Torres.06353621.jpg";